export enum GraphKinds {
  RangeOfMotion = 1,
  Line = 2,
}
